var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "337.13 374.45 10 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "345.9 374.45 347.13 374.45 342.13 379.45 337.13 374.45 338.36 374.45 342.13 378.22 345.9 374.45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownThin);
export default __webpack_public_path__ + "static/media/chevron-down-thin.14cb657b8d96aea0131953b31a33b1af.svg";
export { ForwardRef as ReactComponent };